// constants
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
import RugpullDetectiveNFT from "../../build/contracts/RugpullDetectiveNFT.json";
import SurelockHolmesNFT from "../../build/contracts/SurelockHolmesNFT.json";
import CarmellaSantiagoNFT from "../../build/contracts/CarmellaSantiagoNFT.json";
import MoBoostedNFT from "../../build/contracts/CarmellaSantiagoNFT.json";
import JanBondNFT from "../../build/contracts/CarmellaSantiagoNFT.json";
import RUGPULL from "../../build/contracts/RUGPULL.json";
import DETECTIVESGUILD from "../../build/contracts/DETECTIVESGUILD.json";
import TDGStakingPool from "../../build/contracts/TDGStakingPool.json";
// log
import { fetchData } from "../data/dataActions";

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};

const updateAccountRequest = (payload) => {
  return {
    type: "UPDATE_ACCOUNT",
    payload: payload,
  };
};

export const connect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());
    const { ethereum } = window;
    const metamaskIsInstalled = ethereum && ethereum.isMetaMask;
    if (metamaskIsInstalled) {
      Web3EthContract.setProvider(ethereum);
      let web3 = new Web3(ethereum);
      web3.eth.transactionBlockTimeout = 200;
      web3.eth.transactionPollingTimeout = 1000;
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        const networkId = await ethereum.request({
          method: "net_version",
        });
        // Test Net
        // const rdNFTData = "0x24bf69D08a4ecF78AD3d1535748c4b54cEa3FeCB";
        // const shNFTData = "0xC7C132e88d315Ff2aD12C63cb1D0441a47e2925F";
        // const csNFTData = "0x4E7E5470ce9fc6E043BE3Ef3D7D5538927804f26";
        // const jbNFTData = "0xE5d9BBCf47fFb92C8187b9fCEaa91bf00788d069";
        // const mbNFTData = "0x110b678d92C44A815797c78209044B0e28784676";
        // const tdgStakingPoolData = "0x5f785fAA5fFbB33aC4B7D3cE5a78A1684c19De25";
        // const RUGPULLData = "0x22cEafEcAec9A18DCfC58198249C402C87F75F03";
        // const DETECTIVESGUILDData = "0xb9d339bb9bbddf32ec44176487ed7311568354c2";
        // Main Net
        const rdNFTData = "0x6647093cda77a211be470e5eb3cd26202da2a41f";
        const shNFTData = "0x9ffaacff2885448e1c833117a6af425066503429";
        const csNFTData = "0x734b85ec4a24eff77d3453e5db0d419d2e120fb1";
        const jbNFTData = "0x9a625e7246926821799c6E58983eba87cBBAe945";
        const mbNFTData = "0x51788ec25D5a710300218c345C03EB9dD0C3B3dD";
        const tdgStakingPoolData = "0x94546126c61D21FF19C2aEa543F726654598C76D";
        const RUGPULLData = "0x61ecd63e42c27415696e10864d70ecea4aa11289";
        const DETECTIVESGUILDData = "0xb9d339bb9bbddf32ec44176487ed7311568354c2";
        if (networkId == "43114") {
          const DETECTIVESGUILDObj = new Web3EthContract(
            DETECTIVESGUILD.abi,
            DETECTIVESGUILDData
          );
          const RugpullDetectiveNFTObj = new Web3EthContract(
            RugpullDetectiveNFT.abi,
            rdNFTData
          );
          const SurelockHolmesNFTObj = new Web3EthContract(
            SurelockHolmesNFT.abi,
            shNFTData
          );
          const CarmellaSantiagoNFTObj = new Web3EthContract(
            CarmellaSantiagoNFT.abi,
            csNFTData
          );
          const JanBondNFTObj = new Web3EthContract(
            JanBondNFT.abi,
            jbNFTData
          );
          const MoBoostedNFTObj = new Web3EthContract(
            MoBoostedNFT.abi,
            mbNFTData
          );
          const RUGPULLObj = new Web3EthContract(
            RUGPULL.abi,
            RUGPULLData
          );
          const TDGStakingPoolObj = new Web3EthContract(
            TDGStakingPool.abi,
            tdgStakingPoolData
          );
          dispatch(
            connectSuccess({
              account: accounts[0],
              rugpullDetectiveNFT: RugpullDetectiveNFTObj,
              surelockHolmesNFT: SurelockHolmesNFTObj,
              carmellaSantiagoNFT: CarmellaSantiagoNFTObj,
              janBondNFT: JanBondNFTObj,
              moBoostedNFT: MoBoostedNFTObj,
              tdgStakingPool: TDGStakingPoolObj,
              RUGPULL: RUGPULLObj,
              DETECTIVESGUILD: DETECTIVESGUILDObj,
              web3: web3,
              rdnftCA: rdNFTData,
              shnftCA: shNFTData,
              csnftCA: csNFTData,
              jbnftCA: jbNFTData,
              cmbnftCA: mbNFTData
            })
          );
          // Add listeners start
          ethereum.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });
          // Add listeners end
        } else {
          dispatch(connectFailed("Change network to Avalanche MainNet."));
        }
      } catch (err) {
        dispatch(connectFailed("Something went wrong."));
      }
    } else {
      dispatch(connectFailed("Install Metamask."));
    }
  };
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
  };
};
